"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _polished = require("polished");
var rem = function rem(size) {
  return function (props) {
    return (0, _polished.rem)(typeof size === 'string' ? (0, _get.default)(props, size, size) : size, (0, _get.default)(props, 'theme.basePixelSize', 16));
  };
};
var _default = exports.default = rem;